import { NavLink } from "react-router-dom";
import { Box, Text, Button, IconButton } from "@chakra-ui/react";
import { BiArrowBack } from "react-icons/bi";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useTranslation } from "react-i18next";
import { routeTo } from "@/router/routeTo";
import { useAuth } from "@/hooks/useAuth";
import { useSafeBackNavigation } from "@/hooks/useSafeBackNavigation";

const Error403 = () => {
  const { t } = useTranslation(['errors'])
  useDocumentTitle(t('403.title'));
  const { isAuthenticated } = useAuth();

  const goBack = useSafeBackNavigation();

  return (
    <Box>
      <Box>
        <Box>
          <Text as="p">Error 403</Text>
        </Box>
      </Box>
      <Box>
        <IconButton onClick={goBack}>
          <BiArrowBack />
          Go Back
        </IconButton>
        <NavLink to={isAuthenticated ? routeTo.dashboard() : routeTo.root()}>
          <Button>
            Take me home
          </Button>
        </NavLink>
      </Box>
    </Box>
  );
};

export default Error403;